import { ActionType, getType } from 'typesafe-actions';

import { apiActions } from '../api/api.actions';
import { jobActions } from './job.actions';
import type { BlockingAttributesI, JobState, MetricJobResponse, PlanogremFilterState } from './job.types';
import { JobType } from './job.types';

export const INITIAL_JOB_STATE: JobState = {};
export const INITIAL_PLANOGRAM_FILTER_STATE: PlanogremFilterState = {
  filterInfo: 'None',
  filter: [],
};

export const INITIAL_BLOCKING__ATTRIBUTES_STATE: BlockingAttributesI = {
  attributes: {},
  attributesList: [],
  attributesColors: {},
  attributesProducts: {},
};

export function job(
  state: JobState = INITIAL_JOB_STATE,
  action: ActionType<typeof apiActions | typeof jobActions>
) {
  switch (action.type) {
    case getType(jobActions.setInitialJob): {
      return INITIAL_JOB_STATE;
    }
    case getType(apiActions.launchOptimizationJob.success):
      return {
        ...action.payload,
        type: JobType.optimized,
        timeOfLastCall: new Date(),
        numberOfPolls: 0,
      };
    case getType(apiActions.launchOptimizationJob.failure):
      return state;
    case getType(apiActions.getOptimizationStatus.success):
      return {
        ...action.payload,
        type: JobType.optimized,
        numberOfPolls: state.numberOfPolls ? state.numberOfPolls + 1 : 1,
        timeOfLastCall: new Date(),
      };
    case getType(apiActions.getOptimizationStatus.failure):
      return {
        ...state,
        type: JobType.optimized,
        numberOfPolls: state.numberOfPolls ? state.numberOfPolls + 1 : 1,
        timeOfLastCall: new Date(),
      };
  }

  return state;
}

export function planogramFilter(
  state: PlanogremFilterState = INITIAL_PLANOGRAM_FILTER_STATE,
  action: ActionType<typeof jobActions>
): PlanogremFilterState {
  switch (action.type) {
    case getType(jobActions.setFilterInfo):
      return {
        ...state,
        filterInfo: action.payload,
      };
    case getType(jobActions.setFilter): {
      return {
        ...state,
        filter: action.payload,
      };
    }
    case (getType(jobActions.clearFilters)): {
      return {
        ...state,
        ...INITIAL_PLANOGRAM_FILTER_STATE
      };
    }
    default:
      return state;
  }
}

export function blockingAttributesFilter(
  state: BlockingAttributesI = INITIAL_BLOCKING__ATTRIBUTES_STATE,
  action: ActionType<typeof jobActions>
): BlockingAttributesI {
  switch (action.type) {
    case getType(jobActions.setBlockingAttributes):
      return {
        ...state,
        attributes: action.payload.attributes,
        attributesList: action.payload.attributesList,
        attributesColors: action.payload.attributesColors,
        attributesProducts: action.payload.attributesProducts,
      };

    case getType(jobActions.setBlockingColorAttributes):
      return {
        ...state,
        attributesColors: action.payload,
      };

    default:
      return state;
  }
}

////////////////////////////METRIC FOR JOBID
export const INITIAL_METRIC_STATE: MetricJobResponse = {
  bincap: {},
  facings: {},
  q1f: {},
  total_commitments: {},
  wos: {},
  fill_trips: {},
};

export function metricJob(
  state: MetricJobResponse = INITIAL_METRIC_STATE,
  action: ActionType<typeof apiActions>
): MetricJobResponse {
  switch (action.type) {
    case getType(apiActions.getProductMetrics.success):
      return action.payload;
    case getType(apiActions.getProductMetrics.failure):
      return INITIAL_METRIC_STATE;
  }

  return state;
}

////////////////////////////////////////////////////////////////////////////SOLVER OUTPUT

type PogSolverOutputResponse = {

};

export const INITIAL_SOLVER_OUTPUT_STATE = {};

export function solverOutput(
  state: any = INITIAL_SOLVER_OUTPUT_STATE,
  action: ActionType<typeof apiActions>
): PogSolverOutputResponse {
  switch (action.type) {
    case getType(apiActions.getPogSolverOutput.failure):
      return INITIAL_SOLVER_OUTPUT_STATE;
    case getType(apiActions.getPogSolverOutput.request):
    case getType(apiActions.autoSavedPogSolverOutput.request): {
      // getPogSolverOutput.request carries the whole params object while
      // autoSavedPogSolverOutput.request carries a bare job id, so the requested job id has to be
      // read from either shape. Comparing the raw payload against state.job_id (a string) never
      // matched for the params object, which meant every refresh wiped an already loaded POG and
      // made the visualizer fall back to its loader even when the same job was being re-fetched.
      const requestedJobId = typeof action.payload === 'string' ? action.payload : action.payload?.jobId;

      if (
        requestedJobId &&
        (requestedJobId === state.job_id || requestedJobId === state.parent_job_id)
      ) {
        return state;
      }

      return INITIAL_SOLVER_OUTPUT_STATE;
    }
    case getType(apiActions.getPogSolverOutput.success):
    case getType(apiActions.autoSavedPogSolverOutput.success):
      return action.payload;
    case getType(apiActions.flipPog.success):
      return action.payload.solver_output;
    case getType(apiActions.saveNewEditedPog.success):
    case getType(apiActions.updateEditedPog.success):
      return action.payload.solver_output;
  }

  return state;
}
